function determineValidRedemptionOptions(
    cardLinkEnabled: boolean,
    eGiftEnabled: boolean,
    whiteLabelProgramConfig: any
): {
    allowEGift: boolean
    allowCardLink: boolean
    allowChangeMerchant: boolean
    allowPlastic: boolean
} {
    if (!whiteLabelProgramConfig) {
        return {
            allowEGift: eGiftEnabled,
            allowCardLink: cardLinkEnabled,
            allowChangeMerchant: true,
            allowPlastic: false,
        }
    }

    const programAllowsEGift = whiteLabelProgramConfig?.egift_enabled ?? true
    const programAllowsLink =
        whiteLabelProgramConfig?.card_to_card_enabled ?? true
    const programAllowsChangeMerchant =
        whiteLabelProgramConfig?.change_merchant_enabled ?? true

    return {
        allowEGift: programAllowsEGift && eGiftEnabled,
        allowCardLink: programAllowsLink && cardLinkEnabled,
        allowChangeMerchant: programAllowsChangeMerchant,
        allowPlastic: false,
    }
}

export default determineValidRedemptionOptions
